import { createContext, useContext, useState, useEffect } from 'react';

const CustomerContext = createContext(null);
const BASE = process.env.REACT_APP_BACKEND_URL;

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null); // null = loading, false = not logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('customer_token');
    if (!token) { setCustomer(false); setLoading(false); return; }
    fetch(`${BASE}/api/customer/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(data => { setCustomer(data || false); })
      .catch(() => setCustomer(false))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, customerData) => {
    localStorage.setItem('customer_token', token);
    setCustomer(customerData);
  };

  const logout = () => {
    localStorage.removeItem('customer_token');
    setCustomer(false);
  };

  const token = localStorage.getItem('customer_token');

  return (
    <CustomerContext.Provider value={{ customer, loading, login, logout, token }}>
      {children}
    </CustomerContext.Provider>
  );
}

export function useCustomer() {
  const ctx = useContext(CustomerContext);
  if (!ctx) throw new Error('useCustomer must be used within CustomerProvider');
  return ctx;
}
